const SINGUP_API = "https://crmgeni.com/apis/login.php";
const SIGNIN_API = "https://crmgeni.com/apis/login.php";

const CRUD_Domains = "https://crmgeni.com/apis/Payu/CRUD_Domains.php"
const generate_hash = "https://crmgeni.com/apis/Payu/generate_hash.php"

const CRUD_Price_table = "https://crmgeni.com/apis/Payu/CRUD_Price_table.php"

const Payment_History = "https://crmgeni.com/apis/Payu/payment_history.php"

const CONTACT_US = "https://crmgeni.com/apis/ContactSubmissions.php"

export { SINGUP_API,SIGNIN_API,CRUD_Domains,generate_hash,CRUD_Price_table,Payment_History,CONTACT_US
  
};